<template>
  <div class="bg-[#f5f5f5] rounded-lg min-w-[343px] mx-auto p-4">
    <div class="flex">
      <div class="mr-2 shrink-0">
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <JcImg :level="1"
          :src="
            (userInfo && userInfo.headPortrait) ||
            'https://resources.jctrans.com/res/era-h5/h5/img/defaultAccountLogo.jpg'
          "
          :alt="getCnOrEn(companyNameCn || '', companyNameEn || '')"
          class="size-12 rounded-[64px]"
        />
      </div>
      <div class="flex-1 min-w-0">
        <div
          class="h-7 text-paper leading-7 text-[18px] font-popB truncate"
        >
          {{ locale === 'en-US' ? userNameEn : userNameCn }}
        </div>
        <div
          class="h-5 text-paper-200 leading-5 text-sm font-popR truncate"
        >
          {{ locale === 'en-US' ? companyNameEn : companyNameCn }}
        </div>

        <div v-if="compVips?.length" class="flex items-center justify-start">
          <div
            v-for="(vipItem, vipIndex) in compVips"
            :key="vipIndex"
            class="my-1"
          >
            <i
              :class="getOverseaVipHeaderAccountLogoClass(vipItem?.name || '')"
              class="w-[20px] h-[20px] mr-[8px] inline-block"
            />
          </div>
        </div>
        <div v-else class="flex items-center justify-start">
          <div class="my-1">
            <i
              class="w-[63px] h-[20px] mr-[8px] inline-block"
              :class="isCn ? 'vip-account-free-cn' : 'vip-account-free-en'"
            />
          </div>
        </div>
      </div>
      <div
        class="cursor-pointer ml-1 w-6 shrink-0"
        @click="goToMyQRCode"
        v-if="userInfo?.qrCodeUrl"
      >
        <div class="w-6 h-6">
          <!-- 图片二维码 -->
          <img
            :src="userInfo.qrCodeUrl"
            alt="QR Code"
            class="block w-full h-full"
          />
        </div>
      </div>
    </div>
    <div
      class="mt-1 text-center font-popR text-[#F52C5C] h-6 leading-6 text-base cursor-pointer"
      @click="handleSingOut"
    >
      {{ $t('home.SignOut') }}
    </div>
  </div>
</template>

<script lang="ts" setup>
  const { isCn, getOverseaVipHeaderAccountLogoClass } = useVipLogo()
  const { locale, t: i18nT } = useI18n()
  const { logout } = useMySystemStore()
  const { userInfo, userNameCn, userNameEn, companyNameCn, companyNameEn, compVips } =
    storeToRefs(useMyUserStore())
  const goToMyQRCode = () => {
    navigateTo(`/${isCn ? 'cn' : 'en'}/my-qrcode`)
  }
  const handleSingOut = () => {
    showConfirmDialog({
      message:
        locale.value === 'en-US' ? 'Confirm Logout ?' : '确认退出登录吗？',
      confirmButtonText: i18nT('common.confirm'),
      cancelButtonText: i18nT('common.cancel'),
    })
      .then(async () => {
        await logout()
        navigateTo('/')
      })
      .catch(() => {})
  }
</script>

<style>
  :root {
    --van-dialog-confirm-button-text-color: #ff6a00;
  }
</style>
